module.exports = __webpack_public_path__ + "img/default_avatar.9eec22b9.svg";